// export const BASE_URL = "http://18.159.82.242:9071/api/v1";
// export const BASE_URL = "http://18.159.82.242/v1";
// export const BASE_URL = "http://localhost:3100/v1";
// export const BASE_URL = "http://15.207.186.243:3100/v1";
// export const BASE_URL = "https://dev.tor.digital/v1";
export const BASE_URL = "https://api.tor.digital/v1";

// Admin dashboard URL (for SSO redirect after registration)
// export const DASHBOARD_URL = "http://localhost:3001";
// export const DASHBOARD_URL = "https://dev-dash.tor.digital";
export const DASHBOARD_URL = "https://dash.tor.digital";